// extracted by mini-css-extract-plugin
export default {"BestRatedBooks":"BestRatedBooks_BestRatedBooks__syOlN","List":"BestRatedBooks_List__GJ7-T"};